module.exports = __webpack_public_path__ + "fonts/Manrope-Bold.2af19b38.ttf";